import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '../interceptors/auth.interceptor';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { DatePipe } from '@angular/common';
import { reducers } from './store/reducers';
import { effects } from './store/effects';
import { MatNativeDateModule } from '@angular/material/core';
import { FormlyModule } from '@ngx-formly/core';
import { CustomFormly } from './custom-formly-input';
import { CustomFormlyDropdown } from './custom-formly-dropdown';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslationLoader } from '../_translation/custom-translation-loader';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { CustomFormlyNumber } from './custom-formly-number';
import { CustomFormlyDate } from './custom-formly-date';
import { CustomFormlyTime } from './custom-formly-time';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    importProvidersFrom(MatNativeDateModule),
    provideStore(reducers),
    provideEffects(effects),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    importProvidersFrom(FormlyModule.forRoot({
      types: [
        { name: 'customInput', component: CustomFormly },
        { name: 'customNumber', component: CustomFormlyNumber },
        { name: 'customDate', component: CustomFormlyDate },
        { name: 'customDropdown', component: CustomFormlyDropdown },
        { name: 'customTime', component: CustomFormlyTime }
      ],
    }),
      TranslateModule.forRoot({
        defaultLanguage: navigator.language.split('-')[0],
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslationLoader,
          deps: [HttpClient],
        },
      }),
    ), provideServiceWorker('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000'
          }),

  ]
};
